import usePrivateAxios from '@/common/api/usePrivateAxios'
import { TmaisFaqData, TmaisFaqResponse } from '@/features/tmaisFaqs/types/tmaisFaq.type'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

export const useTmaisFaq: (id: string) => UseQueryResult<TmaisFaqData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<TmaisFaqResponse, unknown, TmaisFaqData>({
    queryKey: ['tmaisFaq', id],
    queryFn: () => privateAxios.get(`/tmais/faqs/${id}`),
    select: (response) => response?.data?.data,
  })
}
